import {BaseCachedService} from './Core/BaseCachedService';

class SurveyTypeService extends BaseCachedService {
    get Url() { return super.Url + "/surveyTypes"; }
    get ModelName() { return "Survey Type"; }
    get PrimaryKeyProperty() { return "surveyTypeId"; }
    get TitleProperty() { return "name"; }

    /**
     * Returns the previous and next survey types adjacent to the given surveyTypeId,
     * ordered by conservationActionPhaseId ascending.
     *
     * Only survey types with a positive conservationActionPhaseId are included.
     * Builds the lookup in a single sort + index pass.
     *
     * @returns {{ prev: object|null, next: object|null }}
     */
    getSurroundingSurveyTypes(surveyTypeId) {
        const all = this.CachedValues()?.result ?? [];
        const phased = [...all]
            .filter(st => st.conservationActionPhaseId > 0)
            .sort((a, b) => a.conservationActionPhaseId - b.conservationActionPhaseId);

        const idx = phased.findIndex(st => st.surveyTypeId === surveyTypeId);
        if (idx < 0) return { prev: null, next: null };

        return {
            prev: idx > 0 ? phased[idx - 1] : null,
            next: idx < phased.length - 1 ? phased[idx + 1] : null,
        };
    }
}

export const service = new SurveyTypeService();

